<template>
    <div class="page_content" aria-label="Enroll Observer Page Content">
		<div class="row page-heading mx-0">
			<div class="col-8 input module_heading" role="heading" aria-level="1">
				<span class="module_icon icon-course"></span>
				<span class="module_type_name">Enroll Observers :: {{ title }}</span>
			</div>
			<div class="col-4 submit btn-container text-right">
				<button type="button" class="btn btn-primary" @click="saveAndDone" aria-label="save & done">save & done</button>
				<button type="button" class="btn btn-primary" @click="cancel" aria-label="cancel">cancel</button>
			</div>
		</div>

        <b-container fluid class="facets-search-grid-container">
            <b-row>
                <div class="facets facets-role-col col-3">
                    <div class="search-row">
                        <input type="text" class="input-search" placeholder="search user" @input="searchUser" aria-label="search user" v-model.trim="searchTerm">
                        <div class="clear-btn" v-if="this.searchTerm.length > 0" @click="searchUser">
							<b-btn @click="searchTerm = ''" aria-label="clear">X</b-btn>
						</div>
						<!-- <button type="button" class="btn btn-primary" @click="searchUser" aria-label="go">Go</button>-->
                    </div>
                    <div class="main_head">
                        <span class="head_txt">Narrow Your Results</span>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="head">
                                <div class="head_txt">Role</div>
                            </div>

                            <div class="facet_row_container">
                                <b-form-group aria-label="select user role">
                                    <b-form-checkbox-group plain stacked v-model="selectedRoles" :options="userRoles" @input="getUsersForRole" aria-label="users role list"/>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="facets facets-user-col col-4">
                    <div class="main_head">
                        <span class="head_txt">Users</span>
                        <span class="float-right">
                            <button type="button" class="btn btn-primary" @click="enrollUsers" aria-label="enroll" :disabled="(selectedUsers.length === 0)">enroll</button>
                        </span>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <template v-if="shouldShowNoResultFound">
                                    <span class="no-result">No results found!</span>
                                </template>
                                <template v-else>
                                    <b-form-group aria-label="selected users">
                                        <b-form-checkbox-group plain stacked v-model="selectedUsers" @input="changeSelectedUsers" aria-label="selected users list">
                                            <template v-for="user in userList">
                                                <b-form-checkbox :value="user" :disabled="user.special" :class="{'special': user.special}"><span class="check-description">{{ user.title }}</span></b-form-checkbox>
                                            </template>
                                        </b-form-checkbox-group>
                                    </b-form-group>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="facets facets-enrolledUser-col col-4">
                    <div class="main_head">
                        <span class="head_txt">Enrolled Observers</span>
                        <span class="float-right">
                            <span @click="deleteEnrolledUsers" :class="{'icon-bin': true, 'action-link': (model.selectedEnrolledUsers.length > 0)}" :disabled="(model.selectedEnrolledUsers.length === 0)" aria-label="delete" tabindex="0"></span>
                        </span>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <b-form-group aria-label="selected enrolled users">
                                    <b-form-checkbox-group plain stacked v-model="model.selectedEnrolledUsers" @input="changeSelectedEnrolledUsers" aria-label="selected enrolled users list">
                                        <template v-for="enrolledUser in model.enrolledUserList">
                                            <b-form-checkbox :value="enrolledUser" v-if="enrolledUser.show" :disabled="enrolledUser.disabled"><span class="check-description">{{ enrolledUser.title }}</span></b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>
        </b-container>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

        <div>
          <data-loss-prompt ref="dataLossAlert" @okLose="okLose" @saveAndContinue="saveAndContinue"></data-loss-prompt>
        </div>

    </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import DataLossPrompt from '../../common/components/DataLossPrompt'
  import _ from 'lodash'
  import '../../../assets/module/less/folder-management.less'

  export default {
    name: 'enrollObserver',
    props: ['uuid', 'ownerId', 'title'],
    components: {
      DataLossPrompt
    },
    data () {
      return {
        pageSize: 100,
        users: [],
        userList: [],
        selectedUsers: [],
        model: {
          enrolledUserList: [],
          selectedEnrolledUsers: []
        },
        userRoles: ['Observer'],
        selectedRoles: ['Observer'],
        actionType: {ENROLL: 'ENROLL', UNENROLL: 'UNENROLL'},
        searchTerm: '',
        shouldShowNoResultFound: false
      }
    },

    beforeRouteLeave (to, from, next) {
      if (this.dirty) {
        this.nextPage = next
        this.$refs.dataLossAlert.showPrompt()
        next(false)
      } else {
        next()
      }
    },

    mounted () {
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.getEnrolledUserListWithUserList()
        this.$refs.loadingModal.hide()
      }, 500)
    },

    computed: {
      currentInstitutionId () {
        var userObj = JSON.parse(localStorage.getItem('userobj'))
        return userObj.institutionId
      },

      loggedInUserId () {
        var userObj = JSON.parse(localStorage.getItem('userobj'))
        return userObj.uuid
      }
    },

    methods: {
      ...mapActions([
        'loadEnrollUsers',
        'loadUsersForRole',
        'loadEnrolledObserverUsers'
      ]),

      getEnrolledUserListWithUserList () {
        this.loadEnrolledObserverUsers(this.uuid).then(res => {
          this.model.enrolledUserList = []
          $.each(res.content, (i, user) => {
            var result = {
              uuid: user.uuid,
              title: user.firstName + ' ' + user.lastName,
              roles: user.roles,
              isSelected: '',
              show: true,
              disabled: (this.ownerId === user.uuid)
            }
            this.model.enrolledUserList.push(result)
          })
          this.getUsersForRole()
          this.$data.oldModel = _.cloneDeep(this.$data.model)
        })
      },

      getUsersForRole () {
        var roles = this.getSelectedRoles()
        var searchString = $.trim(this.searchTerm)
        var name = (searchString.length === 0) ? undefined : searchString
        this.fetchUsersForRole(roles, this.currentInstitutionId, 0, this.pageSize, name)
      },

      getSelectedRoles () {
        var roleString = ''
        var roles = this.selectedRoles
        for (var i = 0; i < roles.length; i++) {
          roleString += roles[i]
          if (i < (roles.length - 1)) {
            roleString += '|'
          }
        }
        return roleString
      },

      fetchUsersForRole (role, parentSpaceId, page, pageSize, name) {
        var data = {
          role: role,
          parentSpaceId: parentSpaceId,
          page: page,
          count: pageSize,
          name: name
        }
        this.loadUsersForRole(data).then(res => {
          this.userList = []
          $.each(res.content, (i, user) => {
            var result = {
              uuid: user.uuid,
              title: user.firstName + ' ' + user.lastName,
              roles: user.roles,
              isSelected: '',
              action: ''
            }
            this.userList.push(result)
          })
          if (this.userList.length > 0) {
            this.shouldShowNoResultFound = false
            this.userList = this.postProcessSearch(this.userList, this.model.enrolledUserList)
          } else {
            this.shouldShowNoResultFound = true
          }
        })
      },

      postProcessSearch (fromList, toList) {
        $.each(fromList, (i, fromListItem) => {
          $.each(toList, (j, toListItem) => {
            if (fromListItem.uuid === toListItem.uuid) {
              if (toListItem.action !== 'UNENROLL') {
                fromListItem['special'] = true
                fromListItem.isSelected = false
              } else if (toListItem.action === 'UNENROLL') {
                fromListItem['special'] = false
              }
            }
          })
        })
        return fromList
      },

      changeSelectedUsers () {
        $.each(this.userList, (i, entity) => {
          entity.isSelected = false
        })
        this.selectedUsers.forEach((user) => {
          user.isSelected = true
        })
      },

      changeSelectedEnrolledUsers () {
        this.model.selectedEnrolledUsers.forEach((user) => {
          user.isSelected = true
        })
      },

      enrollUsers () {
        this.processEnrollAction(this.actionType.ENROLL)
        this.selectedUsers = []
      },

      processEnrollAction (action) {
        var enrolledUsers = []
        $.each(this.userList, (i, entity) => {
          if (entity.isSelected && !entity.special) {
            entity.action = action
            entity.show = true
            enrolledUsers.push(entity)
          }
        })
        this.model.enrolledUserList = _.unionBy(this.model.enrolledUserList, enrolledUsers, 'uuid')
        this.userList = this.postProcessSearch(this.userList, this.model.enrolledUserList)
      },

      deleteEnrolledUsers () {
        this.processUnenrollAction(this.actionType.UNENROLL)
        this.model.selectedEnrolledUsers = []
      },

      processUnenrollAction (action) {
        $.each(this.model.selectedEnrolledUsers, (i, entity) => {
          entity.action = 'UNENROLL'
          entity.show = false
          entity.isSelected = false
          this.userList.forEach((user) => {
            if (user.uuid === entity.uuid) {
              user.special = false
            }
          })
        })
      },

      cancel () {
        return this.$router.push({name: 'enrollmentPage', params: { uuid: this.uuid }})
      },

      saveAndDone () {
        this.$refs.loadingModal.show()
        // var arrayOfUUID = this.getListOfUUIDsOfEnrolledUser()
        var data = {
          uuid: this.uuid,
          userUuidList: this.model.enrolledUserList
        }
        this.loadEnrollUsers(data).then(res => {
          this.dirty = false
          this.$refs.loadingModal.hide()
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Observers enrolled successfully.'
          })
          if (this.nextPage) {
            this.$emit('resolveNext', this.nextPage)
          } else {
            return this.$router.push({name: 'enrollmentPage', params: { uuid: this.uuid }})
          }          
        })
      },

      getListOfUUIDsOfEnrolledUser () {
        var listOfUUIDs = []
        $.each(this.model.enrolledUserList, (i, user) => {
          listOfUUIDs.push(user.uuid)
        })
        return listOfUUIDs
      },

      searchUser () {
        this.refreshList()
      },

      refreshList () {
        this.userList = []
        this.getUsersForRole()
      },

      okLose () {
        this.$emit('resolveNext', this.nextPage)
      },

      saveAndContinue () {
        this.saveAndDone()
      }
    },

    watch: {
      model: {
        handler () {
          this.dirty = !_.isEqual(this.$data.model, this.$data.oldModel)
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
    .heading {
        font-size: 22px;
        font-weight: 400;
        margin-bottom: 8px;
        height: 42px;
    }

    .special {
        background-color: #E3F4FF!important;
    }

    .action-link {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/app/course/components/EnrollObserver.vue